<template>
  <div
    id="app"
    class="common-max-width"
    :class="envClass">
    <router-view />
  </div>
</template>

<script>
import { isIOS, isInIframe } from '@/utils/index'
export default {
  name: 'App',
  data () {
    return {
      envClass: {
        'platform-ios': isIOS,
        'within-iframe': isInIframe
      }
    }
  },
  mounted () {
    this.setResizeData()
    window.onresize = () => {
      this.setResizeData()
    }
  },
  destroyed () {
    window.onresize = null
  },
  methods: {
    setResizeData () {
      this.$store.commit('setResizeData', {
        clientWidth: document.body.clientWidth
      })
    }
  }

}
</script>

<style>
@media (max-width: 500px) {
  html,
  body {
    padding: 0 0;
    margin: 0 auto;
    font-size: 3vw;
    text-align: center;
    background-color: #000;
  }
}

@media (min-width: 501px) {
  html,
  body {
    padding: 0 0;
    margin: 0 auto;
    font-size: 15px;
    text-align: center;
    background-color: #000;
  }
}

#app {
  padding: 0 0;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  text-align: center;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue